import { i18n } from '$lib/i18n/i18n.svelte';

/** Parses what people type: "1,5", "1.5", " 2 " → number; blank or junk → null. */
export function parseAmount(text: string | number | null | undefined): number | null {
	if (text === null || text === undefined) return null;
	const value = Number.parseFloat(String(text).trim().replace(',', '.'));
	return Number.isFinite(value) ? value : null;
}

/** Number formatting without grouping, in the UI language: 1.5 → "1,5", 2 → "2". */
export function formatAmount(amount: number | null | undefined): string {
	if (amount === null || amount === undefined) return '';
	return String(Math.round(amount * 10) / 10).replace('.', i18n.t.number.decimalSeparator);
}

/** "1,5 kg"; empty when there is no amount. */
export function formatQuantity(amount: number | null | undefined, unit: string): string {
	return amount ? `${formatAmount(amount)} ${unit}` : '';
}

/** Splits a typed amount with its unit: "2 l" → 2 l, "10stk" → 10 stk; without a unit it counts pieces. */
export function parseQuantity(text: string): { amount: number | null; unit: string } {
	const match = /^\s*([\d.,]*)\s*(.*?)\s*$/.exec(text) ?? [];
	return { amount: parseAmount(match[1] || null), unit: match[2] || 'stk' };
}
